import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "Inner",
  componentId: "sc-mw92b8-0"
})(["display:flex;flex-flow:column;flex-grow:1;flex-shrink:0;width:100%;height:97%;border:1px solid ", ";border-radius:8px;box-shadow:", ";margin-bottom:1rem;background-color:", ";transition:box-shadow 0.3s ease-in-out;:hover{box-shadow:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.terciaryL;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.shadows.lightBlack;
}, function (_ref3) {
  var theme = _ref3.theme,
    primaryBackground = _ref3.primaryBackground;
  return primaryBackground ? theme.colors.primaryLL : theme.cardsBackgroundColor;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.shadows.extraBlack;
});